import React from 'react'
import { connect } from 'react-redux'
import Input from './Input'
import SubmitButton from './SubmitButton'
import { Message } from '../../locale/Message'
import { bindActionCreators } from 'redux'
import { changeEmailAction, sendOtpAction, getUserInfoAction } from '../../actions/Actions'

class ChangeEmailForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      email: '',
      otp: '',
      error: {},
      isLoading: false,
      step: 'email', // 'email' or 'otp'
      countdown: 0,
      attempts: 0,
      lastAttemptTime: null
    }
    this.countdownInterval = null
  }

  componentDidMount() {
    this.loadAttemptData();
    this.checkCountdown();
  }

  componentWillUnmount() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  }

  loadAttemptData = () => {
    const data = localStorage.getItem('emailChangeAttempts')
    if (data) {
      try {
        const parsed = JSON.parse(data)
        const now = Date.now()
        const timePassed = now - parsed.timestamp

        // TTL = 30 minutes
        if (timePassed < 30 * 60 * 1000) {
          this.setState({
            attempts: parsed.attempts,
            lastAttemptTime: parsed.timestamp
          })
        } else {
          localStorage.removeItem('emailChangeAttempts')
        }
      } catch (e) {
        localStorage.removeItem('emailChangeAttempts')
      }
    }
  }

  saveAttemptData = () => {
    const now = Date.now();

    const data = {
      attempts: this.state.attempts + 1,
      timestamp: now
    };
    localStorage.setItem('emailChangeAttempts', JSON.stringify(data))
    this.setState({
      attempts: data.attempts,
      lastAttemptTime: now
    });
  }

  checkCountdown = () => {
    const data = localStorage.getItem('emailChangeAttempts')
    if (data) {
      try {
        const parsed = JSON.parse(data)
        const now = Date.now()
        const timePassed = now - parsed.timestamp
        const attempts = parsed.attempts
        
        // TTL = 30 minutes
        if (timePassed < 30 * 60 * 1000) {
          let requiredWaitTime = 0
          if (attempts === 1) {
            requiredWaitTime = 2 * 60 // 2 minutes
          } else if (attempts >= 2) {
            requiredWaitTime = 5 * 60 // 5 minutes
          }
          
          const remainingTime = Math.max(0, requiredWaitTime - timePassed / 1000)
          if (remainingTime > 0) {
            this.setState({ countdown: Math.ceil(remainingTime) })
            this.startCountdown()
          }
        } else {
          this.setState({
            attempts: 0,
            lastAttemptTime: null,
            countdown: 0
          })
          localStorage.removeItem('emailChangeAttempts')
        }
      } catch (e) {
        localStorage.removeItem('emailChangeAttempts')
      }
    }
  }

  startCountdown = () => {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }

    this.countdownInterval = setInterval(() => {
      this.setState(prevState => {
        const newCountdown = prevState.countdown - 1
        if (newCountdown <= 0) {
          clearInterval(this.countdownInterval)
          return { countdown: 0 }
        }
        return { countdown: newCountdown }
      })
    }, 1000)
  }

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  formatCountdown = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    if (mins > 0) {
      return `${mins} ${Message.minutes[this.props.lang]} ${secs} ${Message.seconds[this.props.lang]}`
    }
    return `${secs} ${Message.seconds[this.props.lang]}`
  }

  canSendOtp = () => {
    const { attempts, lastAttemptTime, countdown } = this.state

    if (countdown > 0) return false

    if (attempts === 0) return true

    const now = Date.now()
    const timePassed = (now - lastAttemptTime) / 1000

    if (attempts === 1 && timePassed >= 2 * 60) return true
    if (attempts >= 2 && timePassed >= 5 * 60) return true

    return false
  }

  sendOtp = () => {
    const { email } = this.state
    const { lang, sendOtp } = this.props
    const error = {}

    if (!email) {
      error.email = Message.enterEmail[lang]
    } else if (!this.validateEmail(email)) {
      error.email = Message.invalidEmail[lang]
    }

    if (Object.keys(error).length > 0) {
      this.setState({ error })
      return
    }

    if (!this.canSendOtp()) {
      error.general = Message.tooManyAttempts[lang]
      this.setState({ error })
      return
    }

    this.setState({ isLoading: true, error })

    sendOtp({
      email,
      onSuccess: () => {
        this.saveAttemptData();
        this.checkCountdown();
        this.setState({
          isLoading: false,
          step: 'otp',
          error: {}
        })
      },
      onFailure: err => {
        if (err && (err.status === 429 || err.code === 'too-many-otp-requests')) {
          error.general = Message.tooManyOtpRequests[lang]
        } else {
          error.general = Message.server_error[lang]
        }
        this.setState({ isLoading: false, error })
      }
    })
  }

  changeEmail = () => {
    const { email, otp } = this.state
    const { lang, changeEmail, getUserInfo } = this.props
    const error = {}

    if (!otp) {
      error.otp = Message.enterOtp[lang]
    }

    if (Object.keys(error).length > 0) {
      this.setState({ error })
      return
    }

    this.setState({ isLoading: true, error })

    changeEmail({
      email,
      otp,
      onSuccess: () => {
        // Clear attempt data on success
        localStorage.removeItem('emailChangeAttempts')
        // Refresh user info to get updated email
        getUserInfo()
        this.setState({
          isLoading: false,
          email: '',
          otp: '',
          step: 'email',
          error: {},
          attempts: 0,
          lastAttemptTime: null,
          countdown: 0
        })
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval)
        }
      },
      onFailure: err => {
        if (err && (err.status === 422 || err.code === 'invalid-otp' || err.message === 'otp_incorrect')) {
          error.otp = Message.otpIncorrect[lang]
        } else {
          error.general = Message.server_error[lang]
        }
        this.setState({ isLoading: false, error })
      }
    })
  }

  onInputChange = event => this.setState({
    [event.target.id]: event.target.value,
    error: { ...this.state.error, [event.target.id]: null }
  })

  render() {
    const { email, otp, error, isLoading, step, countdown } = this.state
    const { lang } = this.props

    const canSendOtp = this.canSendOtp() && !isLoading && email && this.validateEmail(email)
    const canConfirm = !isLoading && otp

    return (
      <div>
        {step === 'email' && (
          <>
            <Input
              type='text'
              value={email}
              id='email'
              className={error?.email || error?.email === null || error?.email === undefined ? '' : 'error'}
              placeholder={Message.newEmail[lang]}
              error={error?.email}
              onInputChange={this.onInputChange}
            />
            {countdown > 0 && (
              <div className="text-center mb-3">
                <small className="text-muted">
                  {Message.waitTime[lang]}: {this.formatCountdown(countdown)}
                </small>
              </div>
            )}
            <SubmitButton
              error={error.general}
              onSubmit={this.sendOtp}
              isLoading={isLoading}
              text={Message.change[lang]}
              disabled={!canSendOtp}
            />
          </>
        )}

        {step === 'otp' && (
          <>
            <Input
              type='text'
              value={otp}
              id='otp'
              placeholder={Message.enterOtp[lang]}
              error={error.otp}
              onInputChange={this.onInputChange}
            />
            {countdown > 0 ? (
              <div className="text-center mb-3">
                <small className="text-muted">
                  {Message.waitTime[lang]}: {this.formatCountdown(countdown)}
                </small>
              </div>
            ) : (
              <div className="text-center mb-3">
                <button
                  type="button"
                  className="btn btn-link text-muted"
                  onClick={this.sendOtp}
                  disabled={isLoading}
                  style={{ fontSize: '14px', padding: '0' }}
                >
                  {Message.resendOtp[lang]}
                </button>
              </div>
            )}
            <SubmitButton
              error={error.general}
              onSubmit={this.changeEmail}
              isLoading={isLoading}
              text={Message.confirmEmailChange[lang]}
              disabled={!canConfirm}
            />
          </>
        )}
      </div>
    )
  }

}

export default connect(
  state => ({
    lang: state.lang,
    userInfo: state.userInfo
  }),
  dispatch => ({
    sendOtp: bindActionCreators(sendOtpAction, dispatch),
    changeEmail: bindActionCreators(changeEmailAction, dispatch),
    getUserInfo: bindActionCreators(getUserInfoAction, dispatch)
  })
)(ChangeEmailForm)